module.exports = __webpack_public_path__ + "img/logo_image.ba564e7b.png";